// src/features/monitoring/components/MonitoringHeader.tsx
import { PageHeader } from '../../../app/components/foundation';

/**
 * Page-top header for Monitoring Foundation. Reuses the shared
 * PageHeader primitive (same contract every other feature's header
 * uses) and puts one disabled placeholder in the actions slot to
 * reserve visual space for a future "افزودن سرویس مانیتور" action. It
 * has no click handler and does nothing yet — wiring it to a real
 * create flow is a later phase, not this one. Same pattern as
 * audit/components/AuditHeader.tsx and
 * security/components/SecurityHeader.tsx.
 */
export function MonitoringHeader() {
  return (
    <PageHeader
      title="مانیتورینگ"
      description="مشاهده وضعیت سلامت و کارایی سرویس‌های پلتفرم به‌صورت لحظه‌ای."
      actions={
        <button
          type="button"
          disabled
          className="vania-monitoring-action-placeholder"
          title="در فاز بعدی فعال می‌شود"
        >
          افزودن سرویس مانیتور
        </button>
      }
    />
  );
}
